import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import localizeFilter from './filters/localize.filter'
import VideoBackground from 'vue-responsive-video-background-player'

Vue.config.productionTip = false
Vue.component('video-background', VideoBackground);
Vue.filter('localize', localizeFilter)//localize filter

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
